import { Agency } from './../../../models/agency.model';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { UtilityService } from 'src/app/shared/services/utility.service';
import { StpRegistrationStorageService } from '../../../services/stp-registration-storage.service';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-agency',
  templateUrl: './agency.component.html',
  styleUrls: ['./agency.component.scss']
})
export class AgencyComponent implements OnInit {
  agencyForm!: FormGroup;
  agency : Agency;
  ministryListDD : any;
  agencyId:any;
  agencyUpdate:any;
  isEditMode : boolean;

  activeStatus: { id: boolean; name: string }[] = [
    { id: true, name: 'Active' },
    { id: false, name: 'Inactive' }
  ];

  constructor(private fb: FormBuilder,
    private stpRegistrationStorageService: StpRegistrationStorageService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private notification: NzNotificationService,
    private nzMessageService: NzMessageService,
    private utilityService: UtilityService) {
      this.agencyId = this.activatedRoute.snapshot.params.id;

      if(this.agencyId!=null)
    {
      this.isEditMode = true;
      this.stpRegistrationStorageService.getAgencyById(this.agencyId).subscribe({
        next: (res: any) => {

          console.log(res.data);
          this.agencyUpdate = res.data;
          this.agencyForm.patchValue(
            {
              id : res.data.id,
              agencyName : res.data.agencyName,
              remarks : res.data.remarks,
              ministryId : res.data.stpMinistry.id,
              activeStatusBool : res.data.active
            }
          )


        },
        error: (error: any) => {
           //this.notification.warning('Warning!!! ', res.message);
        },
      });
    }


      this.stpRegistrationStorageService.getAllStpMinistries().subscribe({
        next: (res: any) => {
          this.ministryListDD = res.data;

        }
      });;
     }

  ngOnInit(): void {
    this.agencyForm = this.fb.group({
      id: [this.agencyId ?? ''],
      ministryId: ['', [Validators.required]],
      remarks: [''],
      agencyName: ['',[Validators.required]],
      activeStatusBool : ['']
    });
  }

  noWhitespaceValidator(): AsyncValidatorFn {
    return (control: AbstractControl): Observable<ValidationErrors | null> => {
      return this.whitespaceValidator(control.value).pipe(
        map((res) => {
          return res ? null : { whitespace: true };
          // NB: Return null if there is no error
        })
      );
    };
  }

  whitespaceValidator(name: string): Observable<boolean> {
    const isWhitespace = (String(name) || '').trim().length === 0;
    const isValid = !isWhitespace;
    return of(isValid ? true : false);
  }

  submitForm(): void {
    console.log(this.agencyForm.value);
    this.agency = this.agencyForm.value;
    this.stpRegistrationStorageService.addAgency(this.agency).subscribe({
      next: (response: any) =>{
        console.log(response);
        if(response.success)
        {
          this.notification.success('Success!', response.data);
        }else
        {
          this.notification.error('Failed!', response.data);
        }


      },
      error: (error: string) => this.notification.error('Failed', error),
    });

    this.resetForm();
  }

  resetForm(): void {
    this.agencyForm.reset();
  }

}
